var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable react/forbid-prop-types, react/sort-comp */

var React = require("react");
var NumberInput = require("../components/number-input.jsx");

var truth = function truth() {
    return true;
};

/* A minor abstraction on top of NumberInput for ranges
 *
 */
var RangeInput = React.createClass({
    displayName: "RangeInput",

    propTypes: {
        value: React.PropTypes.array.isRequired,
        onChange: React.PropTypes.func.isRequired,
        placeholder: React.PropTypes.array,
        checkValidity: React.PropTypes.func
    },

    getDefaultProps: function getDefaultProps() {
        return {
            placeholder: [null, null]
        };
    },

    render: function render() {
        var value = this.props.value;
        var _checkValidity = this.props.checkValidity || truth;

        return React.createElement(
            "div",
            { className: "range-input" },
            React.createElement(NumberInput, _extends({}, this.props, {
                value: value[0],
                checkValidity: function checkValidity(val) {
                    return _checkValidity([val, value[1]]);
                },
                onChange: this.onChange.bind(this, 0),
                placeholder: this.props.placeholder[0]
            })),
            React.createElement(NumberInput, _extends({}, this.props, {
                value: value[1],
                checkValidity: function checkValidity(val) {
                    return _checkValidity([value[0], val]);
                },
                onChange: this.onChange.bind(this, 1),
                placeholder: this.props.placeholder[1]
            }))
        );
    },

    onChange: function onChange(i, newVal) {
        var value = this.props.value;
        if (i === 0) {
            this.props.onChange([newVal, value[1]]);
        } else {
            this.props.onChange([value[0], newVal]);
        }
    }
});

module.exports = RangeInput;


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/range-input.jsx
 ** module id = 243
 ** module chunks = 0 1
 **/